const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://renuka.ethiq.io:3021"};